import { useCallback } from "react";
import { useModalHook } from "../useModal";
import { useLoyaltyContext } from "./useLoyaltyContext";

export const useLoyaltyOffersPopupOpener = () => {
  const { handleModal } = useModalHook();
  const { useLoyaltyService } = useLoyaltyContext();

  const openLoyaltyOffersPopup = useCallback(
    (options?: {
      displayRemainingToEligiableOffer?: boolean;
      isFromHomeScreen?: boolean;
      showPointingMilestonesOnly?: boolean;
      showItemOffersOnly?: boolean;
    }) => {
      if (useLoyaltyService) {
        handleModal(true, "LoyaltyOffersPopup/LoyaltyOffersPopup", {});

        return;
      }

      handleModal(true, "OffersPopup/OffersPopup", {
        componentProps: {
          options: {
            displayRemainingToEligiableOffer:
              options?.displayRemainingToEligiableOffer,
            isFromHomeScreen: options?.isFromHomeScreen,
          },
          showPointingMilestonesOnly: options?.showPointingMilestonesOnly,
          showItemOffersOnly: options?.showItemOffersOnly,
        },
      });
    },
    [handleModal, useLoyaltyService]
  );

  return { openLoyaltyOffersPopup };
};
